module.exports = __webpack_public_path__ + "static/EmmasLogo-71e99b88aca165c6907b014a086b095c.png";